import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchWorkScheduleExecuters } from './workScheduleApi';

export const useWorkScheduleExecutersQuery = ({ companyId }, options = {}) =>
  useQuery(
    workScheduleQueryKeys.executers(companyId),
    () => fetchWorkScheduleExecuters({ companyId }),
    {
      staleTime: Infinity,
      ...options,
      enabled: Boolean(companyId) && options.enabled !== false,
    }
  );
